'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformLink = transformLink;

var _require = require('query-string'),
    decode = _require.decode;

var REG = /^beastapp:\/\/(\S+)[\?\/]([\S\s]+)/i;

var route = {
  'index': '/pages/index/index',
  // 'shop': '/shop?shopId=',
  'brand': '/pages/list/index?',
  'cate': '/pages/list/index?',
  'search': '/pages/list/index?',
  // 'retail': '/retail?',
  'product': '/pages/product/detail/detail?code=',
  'article': '/pages/article/index?articleId=',
  // 'customization-list': `/customization/list?`,
  // 'big-furniture-tips': '/furniture/tips?',
  // 'shop-story': '/shop/story?',
  'group-purchase': '/pages/group-purchase/index?',
  'points-benefit': '/pages-two/points-benefit/index?',
  'points-mall': '/pages-two/points-list/index?',
  'points-coupon': '/pages-two/points-coupon/index?',
  'points-detail': '/pages-two/points-product/detail/detail?productCode=',
  'category': '/pages/category/index?',
  'store': '/pages/store/index?',
  'cart': '/pages/cart/cart?',
  'member': '/pages/my/member?'
};

var params = {
  'brand': 'brandId'
};

function transformLink(_ref) {
  var _ref$link = _ref.link,
      link = _ref$link === undefined ? {} : _ref$link,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title;

  if (!link.type) {
    return '';
  }
  var url = "";
  var tabFlag = false;
  title = encodeURIComponent(title);
  switch (link.type) {
    case 'none':
      return '';
      break;
    case 'product':
      url = '/pages/product/detail/detail?code=' + link.value;
      break;
    case 'article':
      url = '/pages/article/index?articleId=' + link.value;
      break;
    case 'list':
      url = '/pages/list/index?listId=' + link.value + '&title=' + title;
      break;
    case 'new':
      url = '/pages/list/index?new=1&title=' + title;
      break;
    case 'all':
      url = '/pages/list/index?title=' + title;
      break;
    case 'brand':
      url = '/pages/list/index?brandId=' + link.value + '&title=' + title;
      break;
    case 'tag':
      url = '/pages/list/index?labelId=' + link.value + '&title=' + title;
      break;
    case 'bu':
      url = '/pages/list/index?buId=' + link.value + '&title=' + title;
      break;
    case 'category':
      url = '/pages/list/index?categoryId=' + link.value + '&title=' + title;
      break;
    case 'discount':
      url = '/pages/list/index?param=discount&title=' + encodeURIComponent('折扣');
      break;
    case 'group':
      url = '/pages/group-purchase/index?productId=' + link.value;
      break;
    case 'program':
      url = link.value;
      break;
    case 'deeplink':
      url = dealMLink(link.value);
      tabFlag = formatProgramLink(url);
      break;
  }

  if (tabFlag) {
    return {
      url: url,
      type: 'tab'
    };
  } else {
    return {
      url: url
    };
  }
}

function formatProgramLink(link) {
  if (!link) {
    return '';
  }

  var path = ["/pages/index/index", "/pages/category-v2/index", "/pages/store/index", "/pages/cart/cart", "/pages/my/member"];

  var tabFlag = false;
  path.some(function (p) {
    if (link.indexOf(p) !== -1) {
      //存在
      tabFlag = true;
    }
  });

  return tabFlag;

  // const FileSystemManager = wx.getFileSystemManager()
  // FileSystemManager.readFile({
  //   // filePath: '../app.json',
  //   filePath: wx.env.USER_DATA_PATH + '/app.json',
  //   success: function(res) {
  //     console.log(res, "**************")
  //   },
  //   fail: function(fail) {
  //     console.log(fail, "%%%%%%%%%%%%")
  //   }
  // })

}

function dealMLink(link) {
  if (link === 'beastapp://index') {
    link = '/';
  } else {
    link = splitQue(link);
  }

  return link;
}

function splitQue(query) {
  var que = REG.exec(query);
  var type = que[1];
  var search = que[2];
  var name = '';
  // entry
  if (type === 'entry') {
    type = decode(search).name;
  }

  if (type && search) {
    que = matchQue(type, search);
  }

  return que;
}

function matchQue(type, query) {
  var que = '';
  type = type.split('/');

  var path = route[type[0]];
  var pid = params[type[0]];

  if (path) {
    que = type[1] && pid ? '' + path + pid + '=' + type[1] + '&' + query : pid ? '' + path + pid + '=' + query : '' + path + query;
  } else {
    que = '/' + type[0].replace('-', '/');
  }

  return que;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/sdk/lib/navigate/link/miniprogram.js
// module id = 985
// module chunks = 0